export interface Particle {
  id: number;
  left: number;
  delay: number;
  duration: number;
  size: number;
}

export const generateParticles = (count: number): Particle[] => {
  return Array.from({ length: count }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 20,
    duration: 15 + Math.random() * 10,
    size: 2 + Math.random() * 4,
  }));
};
